import React from 'react'
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

const NamingOpportunity = () => {

  const pdfUrl = "./documents/namingOpportunity.pdf";

//   return (
//     <iframe
//       src={pdfUrl}
//       width="100%"
//       height="500px"
//       title="PDF Viewer"
//     />
//   );

  return (
    <div style={{ height: '100vh' }}>
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.10.111/build/pdf.worker.min.js`}>
        <Viewer fileUrl={pdfUrl} />
      </Worker>      
    </div>
  )
}

export default NamingOpportunity
